import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'lib-flexible'
import 'normalize.css'
import * as Pinia from 'pinia'
import VConsole from 'vconsole'
import '@/utils/vant'

// const vconsole = new VConsole()

// import store from './store'

createApp(App).use(router).use(Pinia.createPinia()).mount('#course')
